import { getDoc, getDocs, setDoc, writeBatch } from 'firebase/firestore';
import {
  db,
  docRef,
  studentSubDoc,
  STUDENT_SUBCOLLECTIONS,
} from './config';
import {
  studentSubColForApp,
  isCanonicalAppId,
} from './dataPaths';
import { COLLECTIONS } from '../utils/constants';
import { normalizeEmail } from '../utils/emailUtils';
import { FIRESTORE_MIGRATION_BATCH } from '../utils/firestoreLimits';

/**
 * Giriş sırasında eski yoldan kanonik yola tek seferlik senkron.
 * Kaynak silinmez; uygulama oturumu yalnızca kanonik yolu kullanır.
 */
export async function syncLegacyProfileToCanonical(roleCol, profile, sourceAppId) {
  if (isCanonicalAppId(sourceAppId)) return profile;

  const { id, ...fields } = profile;
  const canonicalRef = docRef(roleCol, id);
  await setDoc(canonicalRef, fields, { merge: true });

  if (roleCol === COLLECTIONS.STUDENTS) {
    await syncLegacyStudentSubcollections(id, sourceAppId);
  }

  const canonicalSnap = await getDoc(canonicalRef);
  if (!canonicalSnap.exists()) return profile;

  const data = canonicalSnap.data();
  return {
    ...data,
    id,
    emailOrPhone: normalizeEmail(data.emailOrPhone || profile.emailOrPhone),
    role: data.role || profile.role,
  };
}

async function syncLegacyStudentSubcollections(studentId, sourceAppId) {
  for (const sub of STUDENT_SUBCOLLECTIONS) {
    const snap = await getDocs(studentSubColForApp(sourceAppId, studentId, sub));
    if (snap.empty) continue;

    const docs = snap.docs;
    for (let i = 0; i < docs.length; i += FIRESTORE_MIGRATION_BATCH) {
      const batch = writeBatch(db);
      docs.slice(i, i + FIRESTORE_MIGRATION_BATCH).forEach((d) => {
        batch.set(studentSubDoc(studentId, sub, d.id), d.data(), { merge: true });
      });
      await batch.commit();
    }
  }
}
